import { render, staticRenderFns } from "./CatalogReservationConfigHeader.vue.html?vue&type=template&id=26dc4a2d&"
import script from "./CatalogReservationConfigHeader.component.js?vue&type=script&lang=vueJs&"
export * from "./CatalogReservationConfigHeader.component.js?vue&type=script&lang=vueJs&"
import style0 from "./CatalogReservationConfigHeader.scss?vue&type=style&index=0&prod&lang=vueScss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports